// Thin fetch wrapper. Network failures surface as `Offline` so callers can fall back to local data.
export class Offline extends Error {
  constructor() {
    super('offline')
  }
}

export class HttpError extends Error {
  /** The JSON error body, when the server sent one (e.g. `{ error: 'wrong pin', triesLeft: 3 }`). */
  constructor(
    public status: number,
    public body: unknown = null,
  ) {
    super(`HTTP ${status}`)
  }
}

export async function api<T>(path: string, init: RequestInit = {}): Promise<T> {
  let res: Response
  try {
    res = await fetch(path, {
      credentials: 'same-origin',
      ...init,
      headers: { 'content-type': 'application/json', ...init.headers },
    })
  } catch {
    throw new Offline()
  }
  if (!res.ok) throw new HttpError(res.status, await res.json().catch(() => null))
  return res.status === 204 ? (undefined as T) : ((await res.json()) as T)
}
